import React from 'react';
import { ToastContainer } from 'react-toastify';
import { BOTPRESS_NOTIFICATION_DEFAULT_PROPS } from './BotpressNotification.constants';
import { BotpressNotificationPropTypes } from './BotpressNotification.types';
import { getToastContainerProps } from './BotpressNotification.utils';
import './BotpressNotification.less';
var defaultProps = BOTPRESS_NOTIFICATION_DEFAULT_PROPS;
export default function BotpressNotification(props) {
  return /*#__PURE__*/React.createElement(ToastContainer, getToastContainerProps(props));
}
BotpressNotification.defaultProps = defaultProps;